import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import reportReadAction from './reportRead.action.json' with { type: 'json' }

const reportReadDefinition = defineReadAutoAction(reportReadAction, 'report')

export default reportReadDefinition
